import { render } from "./tipsOne.vue?vue&type=template&id=f5430b60"
import script from "./tipsOne.vue?vue&type=script&lang=js"
export * from "./tipsOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__